module.exports = __webpack_public_path__ + "img/whatisagallina.8d9b97da.svg";